export default "__VITE_ASSET__D_I6rbaG__"